<template>
  <div style="display: none" />
</template>

<script>
import { setOptions, bootstrap } from 'vue-gtag'

const log = require('bows')('GAnalytics')

export default {
  props: {
    stream: {
      type: String,
      required: true
    },
    userId: {
      type: String,
      required: false
    }
  },
  created() {
    setOptions({
      config: { id: this.stream }
    })
    log(`Set stream: ${this.stream}`)
    bootstrap().then(() => {
      if (this.userId) {
        log(`Set user id: ${this.userId}`)
        this.$gtag.config({ user_id: this.userId })
        this.$gtag.pageview({
          page_title: this.$route.name,
          page_path: this.$route.path,
          page_location: window.location.href
        })
      }
      this.$store.dispatch('TRACKER_INIT', this.$gtag)
    })
  }
}
</script>
